// extracted by mini-css-extract-plugin
module.exports = {"header":"EsyJrr5mLOjTECiFJ88pvQ==","label":"SlyiBBvsFxzOo94oSHwi1Q==","value":"J+1+Wjxe9E5uGEzci52Hqg==","divider":"zhaOwPWzorxIdmGqvKx2JA=="};